<template>
  <!-- When the typed address belongs to an RSS reader, offer following via RSS
       as a second, non-blocking button alongside the subscribe action. Never
       gates the email subscription — purely additive (B-3055). -->
  <ActionButton
    v-if="feedUrl"
    :href="feedUrl"
    :text="t('email.rss.suggestion_link')"
  />
</template>

<script setup lang="ts">
import { computed } from "vue";

import type { Newsletter } from "@/types/newsletter";

import { createTranslator } from "../../lib/utils";
import { rssFeedUrl } from "../lib";
import ActionButton from "./ActionButton.vue";

const props = defineProps<{
  newsletter: Newsletter;
}>();

const t = createTranslator(() => props.newsletter.locale);

const feedUrl = computed(() => rssFeedUrl(props.newsletter));
</script>
